import { render } from "./CollectionHeader.vue?vue&type=template&id=83a59a70&scoped=true"
import script from "./CollectionHeader.vue?vue&type=script&lang=js"
export * from "./CollectionHeader.vue?vue&type=script&lang=js"

import "./CollectionHeader.vue?vue&type=style&index=0&id=83a59a70&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Asus\\Desktop\\vue\\akpa\\akpa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83a59a70"]])

export default __exports__